// Quick view, earlier scenes: the episode's scenes as small tappable panel pictures, newest first, for cutting back to
// one. Used by the New scene page ("Use an earlier scene") and by the strip under the blank panel at the end of the reel.
import { marksOf, type TimelineEpisode } from "../../model/timeline";
import { FrameSvg } from "../../render/FrameSvg";
import { frameWith } from "../timeline/pages/shared";

export function EarlierScenes({ ep, onPick, idPrefix, className }: { ep: TimelineEpisode; onPick: (pictureId: string) => void; idPrefix: string; className?: string }) {
  const scenes = marksOf(ep, "picture");
  return (
    <div className={`sm-earlier${className ? ` ${className}` : ""}`} role="group" aria-label="Earlier scenes">
      {scenes.map((s, i) => [s, i] as const).reverse().map(([s, i]) => (
        <button key={s.id} className="sm-earlier-pic" onClick={() => onPick(s.id)} aria-label={`Scene ${i + 1}`}>
          <FrameSvg id={`${idPrefix}-${i}`} boil={false} frame={frameWith(ep, s.t + 0.01, 0)} />
        </button>
      ))}
    </div>
  );
}
